import z from 'zod'

export const ProgramScheduleTypeSchema = z.enum(['day', 'weekday', 'sequentialWeekday', 'none'])
export type ProgramScheduleType = z.infer<typeof ProgramScheduleTypeSchema>

const WeekdaySchema = z.number().int().positive().describe('1-7 (Mon-Sun)')

const ProgramDayTaskSchema = z.object({
  type: ProgramScheduleTypeSchema.extract(['day']),
  days: z.array(z.number().int().positive()).describe('day in the program starting from 1'),
})
export type ProgramTaskDay = z.infer<typeof ProgramDayTaskSchema>

const WeekdayScheduleSchema = z.object({
  weekday: WeekdaySchema,
  weeks: z.array(z.number().int().positive()).describe('the weeks of the program for this weekday'),
})
export type WeekdaySchedule = z.infer<typeof WeekdayScheduleSchema>

const ProgramWeekdayTaskSchema = z.object({
  type: ProgramScheduleTypeSchema.extract(['weekday']),
  days: z.array(WeekdayScheduleSchema),
})
export type ProgramTaskWeekday = z.infer<typeof ProgramWeekdayTaskSchema>

const ProgramSequentialWeekdayTaskSchema = z.object({
  type: ProgramScheduleTypeSchema.extract(['sequentialWeekday']),
  weekdays: z.array(WeekdaySchema),
})
export type ProgramTaskSequentialWeekday = z.infer<typeof ProgramSequentialWeekdayTaskSchema>

const ProgramNoScheduleSchema = z.object({
  type: ProgramScheduleTypeSchema.extract(['none']),
})
export type ProgramTaskNoSchedule = z.infer<typeof ProgramNoScheduleSchema>

export const ProgramTaskScheduleSchema = z.discriminatedUnion('type', [
  ProgramDayTaskSchema,
  ProgramWeekdayTaskSchema,
  ProgramSequentialWeekdayTaskSchema,
  ProgramNoScheduleSchema,
])
export type ProgramTaskSchedule = z.infer<typeof ProgramTaskScheduleSchema>
